export enum OstPaisEnum {
  CL = "CL",
  PE = "PE",
  CO = "CO",
}
